import type { Point } from "../geometry/Point"
import type { Percentage } from "../units/Units"
import type { ScaleEnum } from "./ScaleEnum"

export type Scale =
  | Percentage
  | Point<Percentage>
  | ScaleEnum
  | string
  | undefined
